<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M0,10C0,10,5,10,5,10C5,10,5,7,5,7C5,7,0,7,0,7C0,7,0,10,0,10C0,10,0,10,0,10ZM1,8C1,8,4,8,4,8C4,8,4,9,4,9C4,9,1,9,1,9C1,9,1,8,1,8C1,8,1,8,1,8ZM15,3C15,3,11,3,11,3C11,3,11,6,11,6C11,6,16,6,16,6C16,6,16,4,16,4C16,3.45,15.55,3,15,3C15,3,15,3,15,3ZM15,5C15,5,12,5,12,5C12,5,12,4,12,4C12,4,15,4,15,4C15,4,15,5,15,5C15,5,15,5,15,5ZM0,4C0,4,0,6,0,6C0,6,5,6,5,6C5,6,5,3,5,3C5,3,1,3,1,3C0.45,3,0,3.45,0,4C0,4,0,4,0,4ZM0,13C0,13.55,0.45,14,1,14C1,14,5,14,5,14C5,14,5,11,5,11C5,11,0,11,0,11C0,11,0,13,0,13C0,13,0,13,0,13ZM6,6C6,6,10,6,10,6C10,6,10,3,10,3C10,3,6,3,6,3C6,3,6,6,6,6C6,6,6,6,6,6ZM6,14C6,14,10,14,10,14C10,14,10,11,10,11C10,11,6,11,6,11C6,11,6,14,6,14C6,14,6,14,6,14ZM7,12C7,12,9,12,9,12C9,12,9,13,9,13C9,13,7,13,7,13C7,13,7,12,7,12C7,12,7,12,7,12ZM11,14C11,14,15,14,15,14C15.55,14,16,13.55,16,13C16,13,16,11,16,11C16,11,11,11,11,11C11,11,11,14,11,14C11,14,11,14,11,14ZM11,10C11,10,16,10,16,10C16,10,16,7,16,7C16,7,11,7,11,7C11,7,11,10,11,10C11,10,11,10,11,10ZM6,10C6,10,10,10,10,10C10,10,10,7,10,7C10,7,6,7,6,7C6,7,6,10,6,10C6,10,6,10,6,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'HeatGrid',
} as DefineComponent
</script>
